import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsManagerService } from '../../admissions-manager.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'admissions-manager-status-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './status-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./status-view.part.scss'],
})
export class AdmissionsStatusViewPart {

	private readonly util = inject(UtilityService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly pageService = inject(AdmissionsManagerService);

	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});
}